<template>
  <div id="app">
    <keep-alive :include="includeUrl">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      includeUrl: [],
      resizeObserver: null
    };
  },
  computed: {},
  created() {
    // this.initResizeObserver();
  },
  mounted() {
    // this.resizeObserver &&
    //   this.resizeObserver.observe(document.documentElement);
  },
  beforeDestroy() {
    // this.resizeObserver && this.resizeObserver.disconnect();
  },
  methods: {
    /**
     * @Description: 监听根节点缩放
     * @return {*}
     */
    initResizeObserver() {
      this.resizeObserver = new ResizeObserver((entries) => {
        const screenWidth = window.innerWidth;
        const screenRatio = Number((screenWidth / 1920).toFixed(3)); // 分辨率相较于1920的比例
        document.documentElement.style.zoom = screenRatio;
      });
    }
  }
};
</script>
<style lang="scss">
#app {
  // overflow: auto;
}
</style>
